module.exports = __webpack_public_path__ + "media/icons/plus-6dcec42a.svg";